var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('v-pagination',{attrs:{"color":_vm.color,"length":_vm.lastPage,"value":_vm.currentPage},on:{"input":_vm.setPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }